const Community = () => {
    return ( 
		<>
		   <div className="home_community">
            <div className="container">
               <div className="home_road_map_heading">
                  <h3><em>JOIN THE</em><br/> COMMUNITY NOW</h3>
               </div>
               <div className="home_community_flex">
                  <div className="home_community_inner aos-init aos-animate" data-aos="fade-right" data-aos-duration="1000">
                     <div className="home_community_text">
                        <p>The Crypto Pilot community enjoys security, sustainability, and wealth growth with many perks, gifts, and investment ideas while helping humanity heal itself with <a href="https://vastself.org/" target="_blank" class="vastself-ahrity">Vast Self Charity's</a> innovative and groundbreaking solutions.</p>
                        <div className="community_flex">
                           <div className="community_inner">
                              <a href="https://discord.gg/46UEWpPQkt" className="btn" target="_blank"> <img src="images/btn_img2.png" title="" alt=""/> <span>JOIN OUR DISCORD</span></a>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="home_community_inner aos-init aos-animate" data-aos="fade-left" data-aos-duration="1000">
                     <div className="home_community_img"> 
                        <img src="images/65.png" title="" alt=""/>
                        {/* <img src="images/693.png" title="" alt=""/> */}
                     </div>
                  </div>
               </div>
            </div>
      </div>
		</>
        
     );
}
 
export default Community;